import { Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';

@Directive({
  selector: '[appScrollSpyHeader]',
  exportAs: 'appScrollSpyHeader'
})
export class ScrollSpyHeaderDirective implements OnChanges {
  /** Current active section id (must match child chip’s [data-id]). */
  @Input() activeId: string | null = null;

  /** If true, auto-nudges on every activeId change. If false, call nudgeToActive() yourself. */
  @Input() auto = false;

  /** Scroll behavior for horizontal nudge. */
  @Input() behavior: ScrollBehavior = 'smooth';

  /** Selector to find chips (default matches your markup). */
  @Input() itemSelector = '[data-id]';

  @Input() enabled = true;

  constructor(private el: ElementRef<HTMLElement>) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (!this.enabled) return;
    if (this.auto && 'activeId' in changes) {
      queueMicrotask(() => this.nudgeToActive());
    }
  }

  /** Public API: call when you want to center the active chip without touching vertical scroll. */
  public nudgeToActive(): void {
    const header = this.el.nativeElement;
    const id = this.activeId;
    if (!header || !id) return;

    const chip = header.querySelector<HTMLElement>(`[data-id="${id}"]`);
    if (!chip) return;

    // Horizontal-only centering
    const chipCenter = chip.offsetLeft + chip.offsetWidth / 2;
    const targetLeft = chipCenter - header.clientWidth / 2;
    const maxLeft = Math.max(0, header.scrollWidth - header.clientWidth);
    const clamped = Math.min(Math.max(targetLeft, 0), maxLeft);

    header.scrollTo({ left: clamped, behavior: this.behavior });
  }
}
